var _style, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEztDefaultImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#EB9E8D;stroke:#ED1C24;stroke-width:7;stroke-miterlimit:10;} .st1{fill:#EB9E8D;stroke:#ED1C24;stroke-width:7;stroke-miterlimit:10;} .st2{fill:#FFFFFF;stroke:#ED1C24;stroke-width:7;stroke-miterlimit:10;}")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.9,70.3 45.3,25.8 104.5,17.3 70.8,63.2 91.7,113.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.9,70.3 45.3,25.8 104.5,17.3 70.8,63.2 91.7,113.2 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18.9,70.3 45.3,25.8 104.5,17.3 70.8,63.2 91.7,113.2 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.3,16.5c5.3,0,9.6,4.2,9.6,9.3c0,5.1-4.3,9.3-9.6,9.3c-5.3,0-9.6-4.2-9.6-9.3C35.7,20.6,40,16.5,45.3,16.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.3,16.5c5.3,0,9.6,4.2,9.6,9.3c0,5.1-4.3,9.3-9.6,9.3c-5.3,0-9.6-4.2-9.6-9.3C35.7,20.6,40,16.5,45.3,16.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.5,8.1c5.3,0,9.6,4.2,9.6,9.3c0,5.1-4.3,9.3-9.6,9.3c-5.3,0-9.6-4.2-9.6-9.3C94.9,12.2,99.2,8.1,104.5,8.1z  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.5,8.1c5.3,0,9.6,4.2,9.6,9.3c0,5.1-4.3,9.3-9.6,9.3c-5.3,0-9.6-4.2-9.6-9.3C94.9,12.2,99.2,8.1,104.5,8.1z  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,61.1c5.3,0,9.6,4.2,9.6,9.3c0,5.1-4.3,9.3-9.6,9.3c-5.3,0-9.6-4.2-9.6-9.3C9.3,65.2,13.6,61.1,18.9,61.1z  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.9,61.1c5.3,0,9.6,4.2,9.6,9.3c0,5.1-4.3,9.3-9.6,9.3c-5.3,0-9.6-4.2-9.6-9.3C9.3,65.2,13.6,61.1,18.9,61.1z  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.3,103.6c5.3,0,9.6,4.2,9.6,9.3c0,5.1-4.3,9.3-9.6,9.3c-5.3,0-9.6-4.2-9.6-9.3  C81.8,107.7,86,103.6,91.3,103.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.6,103.6c5.3,0,9.6,4.2,9.6,9.3c0,5.1-4.3,9.3-9.6,9.3c-5.3,0-9.6-4.2-9.6-9.3  C82,107.8,86.3,103.6,91.6,103.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.2,54.3c5.3,0,9.6,4.2,9.6,9.3c0,5.1-4.3,9.3-9.6,9.3c-5.3,0-9.6-4.2-9.6-9.3C61.7,58.4,65.9,54.3,71.2,54.3  z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.2,54.3c5.3,0,9.6,4.2,9.6,9.3c0,5.1-4.3,9.3-9.6,9.3c-5.3,0-9.6-4.2-9.6-9.3C61.7,58.4,65.9,54.3,71.2,54.3  z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEztDefaultImg);
export default __webpack_public_path__ + "static/media/eztDefaultImg.215a2c87a0cb8cb110921518e9594302.svg";
export { ForwardRef as ReactComponent };